import { Controller } from "@hotwired/stimulus"
import CryptoJS from "crypto-js"

// Connects to data-controller="image-url-generator"
export default class extends Controller {
  static QR_FIXED_URL = "https://e7d00fe6a711.sn.mynetname.net:81/"

  static targets = ["url", "resultadosLink", "resultadosModal", "resultadosQr"]
  static values = {
    accession: String
  }

  connect() {
    this.generate();
  }

  generate() {
    const accessionNumber = this.accessionValue
    const studyInstanceUID = ""
    const seriesInstanceUID = ""
    const entryPoint = "/study/auth/1?"
    const host = "https://e7d00fe6a711.sn.mynetname.net:8090"
    const secretKey = "b807424e1b3385aa8162ab5849aff013d430339f"

    try {
      const url = this.getUrl(
        entryPoint,
        host,
        secretKey,
        accessionNumber,
        studyInstanceUID,
        seriesInstanceUID
      )
      this.applyGeneratedUrl(url)
    } catch (error) {
      console.error("Error generating URL:", error)
      alert(error)
    }
  }

  openResultadosModal(event) {
    event.preventDefault()

    const currentModalElement = event.currentTarget.closest('.modal')
    if (currentModalElement) {
      const currentModal = new bootstrap.Modal(currentModalElement)
      currentModal.hide()
    }

    if (!this.hasResultadosModalTarget) return

    const resultadosModal = new bootstrap.Modal(this.resultadosModalTarget, { backdrop: 'static', keyboard: true })
    resultadosModal.show()
  }

  printQr(event) {
    event.preventDefault()
    if (!this.hasResultadosQrTarget || !this.hasResultadosLinkTarget) return

    const qrImage = this.resultadosQrTarget.src
    const url = this.resultadosLinkTarget.href
    if (!qrImage || !url || url === '#') return

    const printWindow = window.open('', '_blank')
    if (!printWindow) return

    printWindow.document.write(`
      <html>
        <head>
          <title>Acceso a Resultados</title>
          <style>
            body { font-family: Arial, sans-serif; text-align: center; padding: 24px; }
            img { width: 280px; height: 280px; margin: 16px auto; display: block; }
            a { word-break: break-all; color: #0b4f7f; text-decoration: none; }
          </style>
        </head>
        <body>
          <h2>Acceso a Resultados</h2>
          <img id="qr-image" src="${qrImage}" alt="Codigo QR de acceso a resultados" />
          <p><a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a></p>
          <script>
            (function() {
              var printed = false;
              var img = document.getElementById('qr-image');
              function doPrint() {
                if (printed) return;
                printed = true;
                window.focus();
                window.print();
              }
              if (img) {
                if (img.complete) {
                  doPrint();
                } else {
                  img.onload = doPrint;
                  img.onerror = doPrint;
                  setTimeout(doPrint, 2500);
                }
              } else {
                doPrint();
              }
            })();
          </script>
        </body>
      </html>
    `)
    printWindow.document.close()
  }

  applyGeneratedUrl(url) {
    if (this.hasUrlTarget) {
      this.urlTarget.href = url
    }

    if (this.hasResultadosLinkTarget) {
      this.resultadosLinkTarget.href = url
      this.resultadosLinkTarget.textContent = url
    }

    if (this.hasResultadosQrTarget) {
      this.resultadosQrTarget.src = this.qrServiceUrl(this.constructor.QR_FIXED_URL)
    }
  }

  qrServiceUrl(url) {
    return `https://api.qrserver.com/v1/create-qr-code/?size=320x320&data=${encodeURIComponent(url)}`
  }

  getUrl(entryPoint, host, secret, accessionNumber, studyInstanceUID, seriesInstanceUID) {
    if (!accessionNumber && !studyInstanceUID) {
      throw ('StudyInstanceUID/ACC is mandatory')
    }

    let payload
    let url = host + entryPoint

    if (accessionNumber) {
      payload = String(accessionNumber)
      url += 'a=' + accessionNumber
    } else if (studyInstanceUID) {
      payload = studyInstanceUID
      url += 's1=' + studyInstanceUID
    }

    const date = new Date()
    date.setDate(date.getDate())
    let timestamp = date.getTime()

    timestamp = Math.round(timestamp / 1000) + 86400

    payload += timestamp
    url += '&t=' + timestamp

    const hash = CryptoJS.HmacSHA1(payload, secret)
    const hmac = hash.toString(CryptoJS.enc.Hex)
    url += '&h=' + hmac

    if (seriesInstanceUID && seriesInstanceUID.length > 0) {
      url += '&s2=' + seriesInstanceUID.join(',')
    }

    url += "&r=1"

    console.log("Payload:", payload)
    console.log("url generada", url)

    return url
  }
}
